import { http } from '@/core/helpers/http.helper';
import { CommunicationLimit, CommunicationLimits, CommunicationLimitsToServer } from './communication-limits.interface';
import { ApiResource } from '@/core/models/api-resource.interface';
export class CommunicationLimitService {
   async getCommunicationLimits() {
      const response = await http.get<ApiResource<CommunicationLimits>>('/communication-limits');
      return response.data;
   }

   async postCommunicationLimit(limits: CommunicationLimitsToServer) {
      const response = await http.post<ApiResource<CommunicationLimit>>('/communication-limits', limits);
      return response.data;
   }
}
